<template>
  <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">
              {{title}}
            </span>
          </div>
        </div>

        <div id="select-banner" :style="{width:id==5?'80%':''}">
              <el-form :model="form" inline style="display: flex;align-items: center;" label-width="80px">
                <el-form-item label="院校名称" style="display: flex;">
                  <el-input placeholder="请输入院校名称" v-model="form.collegeName" @keyup.enter.native="form.page=1,collegeList()" clearable=""></el-input>
                </el-form-item>
                <el-form-item label="专业名称" style="display: flex;" v-if="id==9 || id==17">
                  <el-input placeholder="请输入专业名称" v-model="form.majorName" @keyup.enter.native="form.page=1,collegeList()" clearable=""></el-input>
                </el-form-item>
                <el-form-item label="所属省份" style="display: flex;" v-if="id!=15">
                  <el-select @change="form.page=1,collegeList()" v-model="form.collegeProvince" placeholder="全部" size="small"  style="width:120px;" clearable>
                    <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="院校性质" style="display: flex;" v-if="id==3 || id==4 || id==5">
                  <el-select @change="form.page=1,collegeList()" v-model="form.collegeNature" placeholder="全部" size="small"  style="width:120px;" clearable>
                    <el-option v-for="item in ['公办','民办']" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item @change="form.page=1,collegeList()" v-if="id==3 || id==5" label="办学层次" style="display: flex;">
                  <el-select v-model="form.collegeLevel" placeholder="全部" size="small" style="width:120px;" clearable>
                    <el-option v-for="item in ['本科','专科']" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="id==2 || id==4 || id==5 || id==9 || id==17" label="院校类型" style="display: flex;">
                  <el-select  @change="form.page=1,collegeList()" v-model="form.collegeType" placeholder="全部" size="small" style="width:120px;" clearable>
                    <el-option v-for="item in collegeTypeArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="display: flex;">
                  <el-button type="success" size="small" @click="collegeList()">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
      </div>

      <div style="width:100%;height: 78%;overflow-y: auto;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}"
          v-loading="loading">
          <el-table-column prop="collegeName" label="学校名称" align="center">
          </el-table-column>
          <el-table-column prop="collegeType" label="学校类型" align="center">
          </el-table-column>
          <el-table-column prop="collegeAdmin" label="主管部门" align="center">
          </el-table-column>
          <el-table-column prop="collegeProvince" label="学校城市" align="center">
          </el-table-column>
          <el-table-column prop="collegeNature" label="院校性质" align="center">
          </el-table-column>
          <el-table-column prop="collegeLevel" label="办学层次" align="center">
          </el-table-column>
          <el-table-column prop="tw0_jianshe" label="双一流专业" align="center" v-if="id==9">

          </el-table-column>
          <el-table-column prop="tese_major" label="国家特色专业" align="center" v-if="id==17">

</el-table-column>

          <el-table-column prop="ruan_pai" v-if="id==4" label="软科排名" align="center">
          </el-table-column>
          <el-table-column prop="xiaoyou_paiming" v-if="id==4" label="校友会排名" align="center">
          </el-table-column>
          <el-table-column v-if="id==2" :label="current_year + '年保研率'" align="center">
            <template slot-scope="scope">
              <span style="color: red;">
                {{scope.row.one_baoyan_lv?(scope.row.one_baoyan_lv * 100).toFixed(2) + '%':"--"}}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="id==2" :label="(current_year-1) + '年保研率'" align="center">
            <template slot-scope="scope">
              <span style="color: red;">
                {{scope.row.two_baoyan_lv?(scope.row.two_baoyan_lv * 100).toFixed(2) + '%':"--"}}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="id==2" :label="(current_year-2) + '年保研率'" align="center">
            <template slot-scope="scope">
              <span style="color: red;">
                {{scope.row.three_baoyan_lv?(scope.row.three_baoyan_lv * 100).toFixed(2) + '%':"--"}}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div style="width: 100%;margin-top: 20px;display: flex;align-items: center;justify-content: center;padding-bottom: 30px;">
          <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.page"
                :page-sizes="[20,100,200]"
                :page-size="form.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
        </div> -->

    </div>
  </div>
  </div>
</template>

<script>
import { collegeList } from "@/api/gw/zonghe.js";
import cityJson from "@/utils/city.json";
export default {
  data() {
    return {
      cityData: cityJson,
      loading: false,
      total: 0,
      list: [],
      form: {
        page: 1,
        limit: 3000,
        type: 1, //1全国高校名单
        collegeName: "",
        collegeProvince: "",
        collegeNature: "",
        collegeLevel: "",
        collegeType: "", //院校类型
        majorName: "", //专业名称
      },
      current_year: "",
      collegeTypeArr: [
        "综合类",
        "理工类",
        "医药类",
        "农林类",
        "艺术类",
        "民族类",
        "语言类",
        "师范类",
        "财经类",
        "体育类",
        "政法类",
        "军事类",
        "其他",
      ],
    };
  },
  props: {
    id: {
      type: Number,
      default: 3,
    },
    title: {
      type: String,
      default: "全国高校名单",
    },
    type: {
      type: String,
      default: "1",
    },
  },
  watch: {
    id(e) {
      this.form = {
        page: 1,
        limit: 50,
        type: 1,
        collegeName: "",
        collegeProvince: "",
        collegeNature: "",
        collegeLevel: "",
        majorName: "",
      };
      this.collegeList();
    },
  },
  mounted() {
    this.collegeList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.limit = val;
      this.collegeList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.collegeList();
    },
    collegeList() {
      this.loading = true;
      let form = { ...this.form };
      form["type"] = this.type;
      collegeList(form)
        .then((res) => {
          this.total = res.data.total;
          this.list = res.data.data;
          this.current_year = res.data.current;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/comprehensive/components/gaoxiao.vue